document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.a24-floating-cart')) return;

  var headerCartLink = document.querySelector('.header__icon--cart');
  var cartUrl = headerCartLink ? headerCartLink.getAttribute('href') : '/cart';

    var link = document.createElement('a');
  link.href = cartUrl;
  link.className = 'a24-floating-cart';
  link.innerHTML =
    '<span class="a24-floating-cart-label">CART</span>' +
    '<span class="a24-floating-cart-count">0</span>';

  document.body.appendChild(link);

  function alignWithHeader() {
    if (!headerCartLink) return;
    var rect = headerCartLink.getBoundingClientRect();
    link.style.top = (rect.top + rect.height / 2) + 'px';
  }
  alignWithHeader();
  window.addEventListener('resize', alignWithHeader);

  var countEl = link.querySelector('.a24-floating-cart-count');

    function syncCount() {
    var bubble = document.querySelector('.header__icon--cart .cart-count-bubble');
    var visible = bubble ? bubble.querySelector('span[aria-hidden="true"]') : null;
    var text = visible ? visible.textContent : (bubble ? bubble.textContent : '');
    countEl.textContent = (text || '0').trim() || '0';
  }
  syncCount();

  var headerIcons = document.querySelector('.header__icons');
  if (headerIcons && window.MutationObserver) {
    var observer = new MutationObserver(syncCount);
    observer.observe(headerIcons, { childList: true, subtree: true, characterData: true });
  }

    var lastScrollY = window.scrollY;
  var ticking = false;
  var SHOW_AFTER = 120;
  function onScroll() {
    var currentScrollY = window.scrollY;
    if (currentScrollY <= SHOW_AFTER) {
      link.classList.remove('is-visible');
    } else if (currentScrollY > lastScrollY) {
      link.classList.add('is-visible');
    } else if (currentScrollY < lastScrollY) {
      link.classList.remove('is-visible');
    }
    lastScrollY = currentScrollY;
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });
});